import type { LiveSession } from "./live-session";

/**
 * La séance en cours, pour la sonde de développement (`__virtuosa.live()`).
 *
 * Rien ne la lit en production. C'est la poignée qui permet d'éprouver les
 * moteurs à la main, ou depuis un banc, là où aucun écran ne les montre encore :
 * le son, qu'aucun contexte n'écoute aujourd'hui.
 */
let current: LiveSession | null = null;

/** La séance que le contexte vient d'ouvrir, ou `null` quand il la démonte. */
export function registerLiveSession(session: LiveSession | null): void {
  current = session;
}

export function currentLiveSession(): LiveSession | null {
  return current;
}
